import BackButton from "../shared/BackButton";
import {
  Avatar,
  Box,
  Chip,
  Typography
  } from "@mui/material";
import { JudgeResult } from "../../interfaces/ICompetitions";

interface ResultsTableHeaderProps {
  roundName?: string;
  categoryName?: string;
  judges?: JudgeResult[];
  onBack?: () => void;
}

export default function ResultsTableHeader({
  roundName,
  categoryName,
  judges,
  onBack,
}: ResultsTableHeaderProps) {
  if (!roundName && !onBack) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 2,
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      {roundName && (
        <Box>
          <Typography
            variant="h6"
            component="div"
            sx={{
              color: "primary.main",
              fontSize: { xs: "1rem", sm: "1.25rem" },
              fontWeight: 600,
            }}
          >
            {roundName}
          </Typography>
          {categoryName && (
            <Typography
              variant="subtitle2"
              component="div"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                mt: 0.5,
              }}
            >
              {categoryName}
            </Typography>
          )}
        </Box>
      )}
      {onBack && <BackButton onClick={onBack} showTooltip={false} />}
      {!!judges?.length && (
        <Box sx={{ width: "100%" }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {judges.map((judge) => (
              <Chip
                key={judge.id}
                avatar={
                  <Avatar sx={{ width: 24, height: 24, fontSize: "0.75rem" }}>
                    {judge.firstName?.[0]}
                    {judge.lastName?.[0]}
                  </Avatar>
                }
                label={`${judge.firstName} ${judge.lastName}`}
                variant="outlined"
                size="small"
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}

